<div class="container bg-white">

    <h2>Politique de confidentialité en ligne</h2>
    <p>SMART-DIGITAL AFRICA SARL ("Société", "nous" ou "notre") respecte votre vie privée et s'engage à la protéger par le
    biais de la présente politique de confidentialité.</p>

    <p>La présente Politique de confidentialité régit votre accès à et votre utilisation de https://softpay.africa, y compris
    tout contenu, toute fonctionnalité et tout service offert sur ou par l'intermédiaire de https://softpay.africa (le "
    Site Internet "), que ce soit en tant qu'invité ou en tant qu'utilisateur enregistré.</p>

    <p>Lorsque vous accédez au site Web, la Société apprend certaines informations vous concernant, à la fois
    automatiquement et par le biais d'actions volontaires que vous pouvez entreprendre, au cours de votre visite. Cette
    politique s'applique aux informations que nous recueillons sur le site Web et dans les courriers électroniques, les
    textes ou autres messages électroniques échangés entre vous et le site Web.</p>

    <p>Veuillez lire attentivement la politique de confidentialité avant de commencer à utiliser le site web.</p>

   <p> En utilisant le site Web ou en cliquant pour accepter les conditions d'utilisation lorsque cette option vous est
    proposée, vous acceptez d'être lié par la politique de confidentialité et de vous y conformer. Si vous ne souhaitez
    pas accepter la politique de confidentialité, vous ne devez pas accéder au site Web ni l'utiliser.</p>

   <p>Enfants de moins de 13 ans : Notre site Web n'est pas destiné aux enfants de moins de 13 ans. Aucune personne âgée
    de moins de 13 ans ne peut fournir d'informations à ou sur le site Web. Nous ne collectons pas sciemment les
    informations personnelles des enfants de moins de 13 ans. Si vous avez moins de 13 ans, n'utilisez pas et ne
    fournissez pas d'informations sur ce site Web ou sur ou par le biais de l'une de ses fonctions, ne vous inscrivez
    pas sur le site Web, n'effectuez pas d'achats par le biais du site Web, n'utilisez pas les fonctions interactives ou
    de commentaires publics de ce site Web et ne nous fournissez pas d'informations vous concernant, y compris votre
    nom, votre adresse, votre numéro de téléphone, votre adresse électronique ou tout nom d'écran ou nom d'utilisateur
    que vous pouvez utiliser.</p>

    <p>Si nous apprenons que nous avons recueilli ou reçu des informations personnelles d'un enfant de moins de 13 ans sans
    vérification du consentement parental, nous supprimerons ces informations. Si vous pensez que nous pourrions détenir
    des informations provenant d'un enfant de moins de 13 ans ou le concernant, veuillez nous contacter à l'adresse
    info&#64;softpay.africa.</p>

    <p>Informations que nous recueillons à votre sujet :<p>

    <p>Lorsque vous accédez au site Web, la Société apprend certaines informations vous concernant au cours de votre
    visite.</p>

    <p>Informations que vous nous fournissez. Le site Web propose différents endroits où les utilisateurs peuvent fournir
    des informations. Nous recueillons les informations que les utilisateurs fournissent en remplissant des formulaires
    sur le site Web, en communiquant avec nous via des formulaires de contact, en répondant à des enquêtes, en
    effectuant des recherches sur notre fonction de recherche, en fournissant des commentaires ou d'autres réactions et
    en fournissant des informations lors de la commande d'un produit ou d'un service via le site Web.</p>

    <p>Nous utilisons les informations que vous nous fournissez pour fournir le produit et/ou le service demandé, pour
    améliorer nos performances générales et pour vous proposer des offres, des promotions et des informations.</p>

    <p>Informations que nous recueillons par le biais de la technologie de collecte automatique des données. Lorsque vous
    naviguez sur notre site Web, nous pouvons utiliser des technologies de collecte automatique de données, notamment
    Google Analytics, pour recueillir certaines informations sur votre équipement, vos actions de navigation et vos
    habitudes. Il s'agit généralement d'informations sur votre localisation, vos habitudes de navigation sur notre site
    Web et toute communication entre votre ordinateur et notre site Web. Entre autres, nous collecterons des données sur
    le type d'ordinateur que vous utilisez, votre connexion Internet, votre adresse IP, votre système d'exploitation et
    votre type de navigateur.</p>

    <p>Les informations que nous recueillons automatiquement sont utilisées pour des données statistiques et ne comprennent
    pas d'informations personnelles. Nous utilisons ces données pour améliorer notre site Web et nos offres de services.
    Dans la mesure où vous nous fournissez volontairement des informations personnelles, nos systèmes associeront les
    informations collectées automatiquement à vos informations personnelles.</p>

   <p> Utilisation de cookies et de pixels :</p>

    <p>Comme d'autres sites Web commerciaux, notre site Web utilise une technologie standard appelée "cookies" et des
    journaux de serveur pour recueillir des informations sur la façon dont notre site est utilisé. Les informations
    recueillies par le biais des cookies et des journaux de serveur peuvent inclure la date et l'heure des visites, les
    pages consultées, le temps passé sur notre site et les sites Web visités juste avant et juste après le nôtre, ainsi
    que votre adresse IP.</p>

   <p> Un cookie est un très petit document texte, qui comprend souvent un identifiant unique anonyme. Lorsque vous visitez
    un site web, l'ordinateur de ce site demande à votre ordinateur la permission de stocker ce fichier dans une partie
    de votre disque dur spécifiquement désignée pour les cookies. Chaque site web peut envoyer son propre cookie à votre
    navigateur si les préférences de ce dernier le permettent, mais (pour protéger votre vie privée) votre navigateur ne
    permet à un site web d'accéder qu'aux cookies qu'il vous a déjà envoyés, et non aux cookies envoyés par d'autres
    sites.</p>

    <p>La société se réserve le droit d'utiliser des équivalents technologiques des cookies, notamment des pixels de médias
    sociaux. Ces pixels permettent aux sites de médias sociaux de suivre les visiteurs de sites Web extérieurs afin
    d'adapter les messages publicitaires que les utilisateurs voient lorsqu'ils visitent ce site Web de médias sociaux.
    La Société se réserve le droit d'utiliser ces pixels en conformité avec les politiques des différents sites de
    médias sociaux.</p>

   
</div>